import { computed, ref } from 'vue';
import { emailReg } from 'src/utils/base';
import { use18n, useIns } from 'src/utils/v2_helper/common';

/**
 * 补充用户信息的自定义钩子
 * 用于OTP关闭并且未登录时管理用户信息表单的填写状态和验证逻辑
 */
export function useFillInfo() {
  const { $t } = use18n();
  const app = useIns();
  // 初始化表单数据结构
  const fillForm = ref({
    nickName: '',
    email: '',
    phone: '',
  });

  // 创建表单字段的引用，用于错误时聚焦字段
  const fillFieldRefs = {
    nickName: ref(),
    email: ref(),
    phone: ref(),
  };

  // 游客显示补充用户信息表单
  const showFillForm = computed(() => app.userInfo.guestUser)

  // 字段校验规则
  const invalidFillPhoneErrMsg = computed(() => {
    if (!fillForm.value.phone) return $t('checkout.inputPhoneNumber');
    return '';
  });
  const invalidFillEmailErrMsg = computed(() => {
    if (!fillForm.value.email) return '';
    if (!emailReg.test(fillForm.value.email)) return $t('checkout.EmailInvalid');
    return '';
  });
  // 计算得到表单验证错误的队列
  const fillFormInvalidQueue = computed(() => [
    { field: 'email', msg: invalidFillEmailErrMsg.value, el: fillFieldRefs.email.value?.el },
    // { field: 'phone', msg: invalidFillPhoneErrMsg.value, el: fillFieldRefs.phone.value?.el },
  ].filter(item => item.msg));

  // 表单是否校验成功
  const fillFormValid = computed(() => fillFormInvalidQueue.value.length === 0);
  // 表单配置项
  const formListConfig = [
    { label: $t('fullDinein.name'), prop: 'nickName', ref: fillFieldRefs.nickName, required: false, max: 30, errMsg: ref(null) },
    { label: $t('checkout.Email'), prop: 'email', ref: fillFieldRefs.email, required: false, max: 30, errMsg: invalidFillEmailErrMsg },
    // { label: $t('checkout.phoneNumber'), prop: 'phone', ref: fillFieldRefs.phone, required: true, max: 30, errMsg: invalidFillPhoneErrMsg },
    { label: $t('checkout.phoneNumber'), prop: 'phone', ref: fillFieldRefs.phone, required: false, max: 30, errMsg: ref(null) },
  ]
  return {
    fillForm,
    fillFieldRefs,
    showFillForm,
    invalidFillEmailErrMsg,
    invalidFillPhoneErrMsg,
    fillFormInvalidQueue,
    fillFormValid,
    formListConfig,
  };
}
